module.exports = __webpack_public_path__ + "static/media/veradero-1.29c43091.jpg";